import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import "./PdfPage.css";
import NoData from "./NoData";
import ChartLoader from "./ChartLoader";
import COmpBiDirTest from "./FaultSecondPageChartsBidirRender_Bus";

// export default function FaultSecondPart(props) {
const FaultSecondPart = forwardRef((props, ref) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [ECUData, setECUData] = useState({});
  const [TempDataHVAC, setTempDataHVAC] = useState([]);
  const [dataMainHVAC, setDataMainHVAC] = useState([]);
  const [toCalculateFaultHVAC, setToCalculateFaultHVAC] = useState(0);
  const [single_nameHVAC, setsingle_nameHVAC] = useState([]);
  const [LineContainerBodyBD, setCssLineCont] = useState({ height: "200px" });
  const [TempDataDCDC, setTempDataDCDC] = useState([]);
  const [dataMainDCDC, setDataMainDCDC] = useState([]);
  const [toCalculateFaultDCDC, setToCalculateFaultDCDC] = useState(0);
  const [single_nameDCDC, setsingle_nameDCDC] = useState([]);
  const [hvac_duration, setHvac_duration] = useState([]);
  const [dcdc_duration, setDcdc_duration] = useState([]);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/faultanalysis_bus",
        body: { filterdata: gloablfilter },
      },
      ecuFaultResponse
    );
  }, [gloablfilter]);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/vehicleLevalBusFault",
        body: { filterdata: gloablfilter, defaultNav: "DC-DC" },
      },
      responceBarData
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/vehicleLevalBusFault",
        body: { filterdata: gloablfilter, defaultNav: "HVAC" },
      },
      responceBarData
    );
  }, [ECUData]);

  useImperativeHandle(ref, () => ({
    getDataForSlide: () => ({
      ECUData,
      TempDataHVAC,
      dataMainHVAC,
      toCalculateFaultHVAC,
      single_nameHVAC,
      LineContainerBodyBD,
      TempDataDCDC,
      dataMainDCDC,
      toCalculateFaultDCDC,
      single_nameDCDC,
      hvac_duration,
      dcdc_duration,
    }),
  }));

  const ecuFaultResponse = (data) => {
    const ecuDict = {};
    data.forEach((item) => {
      const ecu = item.key.ECU;
      const vehicleCount = item.vehicle_count.value;
      ecuDict[ecu] = vehicleCount;
    });
    setECUData(ecuDict);
  };

  const responceBarData = (data) => {
    // setTempData(data)
    if (data.defaultNav === "HVAC") {
      // setTempDataHVAC([]);
      // setDataMainHVAC([]);
      deno(data);
    } else if (data.defaultNav === "DC-DC") {
      // setTempDataDCDC([]);
      // setDataMainDCDC([]);
      deno(data);
    }
  };

  const deno = async (data) => {
    if (data.defaultNav !== null && data.defaultNav === "HVAC") {
      //   if (ECUData.hasOwnProperty(defaultNav)) {
      await setTempDataHVAC(data.result);
      await setToCalculateFaultHVAC(ECUData[data.defaultNav]);
      //   }
    } else if (data.defaultNav !== null && data.defaultNav === "DC-DC") {
      await setTempDataDCDC(data.result);
      await setToCalculateFaultDCDC(ECUData[data.defaultNav]);
    }
  };

  useEffect(() => {
    if (toCalculateFaultHVAC !== 0) {
      const data = TempDataHVAC;
      let dataArray = [];
      let maleAdd = 0;
      let femaleAdd = toCalculateFaultHVAC;
      data.forEach((obj1, index) => {
        maleAdd += obj1.duration.value;
      });
      setHvac_duration(maleAdd.toFixed(0));
      let single_name_array = [];
      data.forEach((obj1, index) => {
        let male = (obj1.duration.value / maleAdd) * 100;
        let female = (obj1.Total_vehicle_count.value / femaleAdd) * 100;
        dataArray.push({
          age: obj1.key.spnname.toUpperCase(),
          male: -male,
          female: female,
          orgLevalMale: obj1.duration.value.toFixed(0).toString(),
          orgLevalFemale: obj1.Total_vehicle_count.value.toString(),
          signal_nm: obj1.key.spnname,
          signal_desc: obj1.key.Description,
          signal_val: obj1.key.spnvalue.toString(),
        });
        single_name_array.push(obj1.key.spnname);
      });
      //   setsingle_nameBCS1(single_name_array);
      for (let i = 0; i < dataArray.length; i++) {
        let count = 0;
        for (let j = i + 1; j < dataArray.length; j++) {
          if (dataArray[i].age === dataArray[j].age) {
            dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
            count = 1;
          }
        }
        if (count) {
          dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
        }
      }
      dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
      setDataMainHVAC(dataArray);
    }

    if (toCalculateFaultDCDC !== 0) {
      const data = TempDataDCDC;
      let dataArray = [];
      let maleAdd = 0;
      let femaleAdd = toCalculateFaultDCDC;
      data.forEach((obj1, index) => {
        maleAdd += obj1.duration.value;
      });
      setDcdc_duration(maleAdd.toFixed(0));
      let single_name_array = [];
      data.forEach((obj1, index) => {
        let male = (obj1.duration.value / maleAdd) * 100;
        let female = (obj1.Total_vehicle_count.value / femaleAdd) * 100;
        dataArray.push({
          age: obj1.key.spnname.toUpperCase(),
          male: -male,
          female: female,
          orgLevalMale: obj1.duration.value.toFixed(0).toString(),
          orgLevalFemale: obj1.Total_vehicle_count.value.toString(),
          signal_nm: obj1.key.spnname,
          signal_desc: obj1.key.Description,
          signal_val: obj1.key.spnvalue.toString(),
        });
        single_name_array.push(obj1.key.spnname);
      });
      //   setsingle_nameBCS1(single_name_array);
      for (let i = 0; i < dataArray.length; i++) {
        let count = 0;
        for (let j = i + 1; j < dataArray.length; j++) {
          if (dataArray[i].age === dataArray[j].age) {
            dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
            count = 1;
          }
        }
        if (count) {
          dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
        }
      }
      dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
      setDataMainDCDC(dataArray);
    }
  }, [toCalculateFaultHVAC, toCalculateFaultDCDC]);

  return (
    <div className="faultfirstpart">
      <div className="row" style={{ justifyContent: "end" }}>
        <img
          src="../../../assets/img_Bus/Pdf_Page/Tatamotors.png"
          alt=""
          style={{ height: "80px", width: "250px" }}
        />
      </div>
      <div className="row mt-2">
        <div className="col-md-8">
          <span
            className="text-left"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#002060",
              paddingLeft: "30px",
            }}
          >
            Faults Observed in Field :{" "}
          </span>
          <span
            className="text-right"
            style={{ color: "#002060", fontSize: "12px" }}
          >
            {props.startdate} - {props.enddate}
          </span>
        </div>
      </div>

      <div className="row mt-3 ">
        <div className="col-md-1"></div>
        <div className="col-md-5">
          <div
            className="row"
            id="faultfirstparttitle_hvac"
            style={{ textAlign: "right" }}
          >
            <div className="col-md-4 text-start">
              <button className="btn" style={{ backgroundColor: "#d0d4d5" }}>
                HVAC
              </button>
            </div>
            <div className="col-md-8 text-end">
              <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                <dt className="red_bus"></dt>
                <dd>Time Duration (mins)</dd>
                <dt className="yellow_bus" style={{ marginLeft: "5px" }}></dt>
                <dd>Vehicle Count</dd>
              </dl>
            </div>
          </div>
          <div className="row pt-1">
            {/* {renderTabContent('BCS-1')} */}
            <div style={LineContainerBodyBD}>
              {isLoading ? (
                <ChartLoader />
              ) : dataMainHVAC.length > 0 ? (
                <div id="faultfirstpart_hvac">
                  <COmpBiDirTest
                    dataMain={dataMainHVAC}
                    id={"HVAC"}
                    gloablfilter={gloablfilter}
                    signal_name={single_nameHVAC}
                  />
                </div>
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>

        <div className="col-md-5">
          <div
            className="row"
            id="faultfirstparttitle_dcdc"
            style={{ textAlign: "right" }}
          >
            <div className="col-md-4 text-start">
              <button className="btn" style={{ backgroundColor: "#d0d4d5" }}>
                DC-DC
              </button>
            </div>
            <div className="col-md-8 text-end">
              <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                <dt className="red_bus"></dt>
                <dd>Time Duration (mins)</dd>
                <dt className="yellow_bus" style={{ marginLeft: "5px" }}></dt>
                <dd>Vehicle Count</dd>
              </dl>
            </div>
          </div>
          <div className="row pt-1">
            <div style={LineContainerBodyBD}>
              {isLoading ? (
                <ChartLoader />
              ) : dataMainDCDC.length > 0 ? (
                <div id="faultfirstpart_dcdc">
                  <COmpBiDirTest
                    dataMain={dataMainDCDC}
                    id={"DC-DC"}
                    gloablfilter={gloablfilter}
                    signal_name={single_nameDCDC}
                  />
                </div>
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row bottomcontent pl-4" style={{ paddingTop: "455px" }}>
        <div className="col-md-3">
          <img
            src="../../../assets/img_Bus/Pdf_Page/footer.png"
            alt=""
            style={{ height: "70px", width: "200px" }}
          />
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-4">
          <p
            style={{
              fontSize: "11px",
              paddingTop: "60px",
              paddingLeft: "10px",
            }}
          >
            Copyright, Confidential, Tata Motors Limited
          </p>
        </div>
      </div>
    </div>
  );
});

export default FaultSecondPart;
